import { render, staticRenderFns } from "./ModalUserReport.vue?vue&type=template&id=1fcfd5e8&scoped=true"
import script from "./ModalUserReport.vue?vue&type=script&lang=js"
export * from "./ModalUserReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcfd5e8",
  null
  
)

export default component.exports